import { render, staticRenderFns } from "./Refuse.vue?vue&type=template&id=164ec576&scoped=true"
import script from "./Refuse.vue?vue&type=script&lang=js"
export * from "./Refuse.vue?vue&type=script&lang=js"
import style0 from "./Refuse.vue?vue&type=style&index=0&id=164ec576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164ec576",
  null
  
)

export default component.exports